module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAMFBMVEUAAJkCApoFBZslJagrK6oyMq01Na5iYsB8fMt9fcuCgs2SktSiotnFxej/AAD////6TaSrAAAANklEQVQY02NggAC+dxAAZDIxM6HwWWpKUPhZe3clIPEZI///CMTDR1ePYR66fajueYcKBhsfAEef2NE7PmJjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/tw.png
// module id = 402
// module chunks = 0